<template>
  <tr>
    <td>
      <router-link
        :to="{
          name: 'single_permission',
          params: { id: props.item.id }
        }"
      >
        {{ props.item.name }}
      </router-link>
    </td>
    <td>
      {{ props.item.code }}
    </td>
    <td>
      {{ scope }}
    </td>
  </tr>
</template>

<script>
export default {
  name: 'PermissionDataTableRow',

  props: {
    props: {
      type: Object,
      required: true
    }
  },

  computed: {
    scope () {
      const item = this.props.item
      return [item.app, item.store, item.action, item.resourceProp].join(':')
    }
  }
}
</script>
